// prettier-ignore
import { type ProctorSpecification } from '../../../shared/proctor/ProctorSpecification';

export const AutoApplyRebrandingTst = {
    name: 'auto_apply_rebranding_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type AutoApplyRebrandingTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const BrandedjobMigrationRnhpTst = {
    name: 'brandedjob_migration_rnhp_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
        Shadow: 2,
    },
} satisfies ProctorSpecification;

export type BrandedjobMigrationRnhpTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
    isShadow: boolean;
};

export const DiscoLimitedUiTst = {
    name: 'disco_limited_ui_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Grp1: 1,
        Grp2: 2,
    },
} satisfies ProctorSpecification;

export type DiscoLimitedUiTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
    isGrp2: boolean;
};

export const HpCarouselV4Tst = {
    name: 'hp_carousel_v4_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        CtrlghpLlmgroups: 1,
        AllCarousels: 2,
        VerticalBookends: 3,
        LastGroupVertical: 4,
    },
} satisfies ProctorSpecification;

export type HpCarouselV4TstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isCtrlghpLlmgroups: boolean;
    isAllCarousels: boolean;
    isVerticalBookends: boolean;
    isLastGroupVertical: boolean;
};

export const HpFirstSectionVerticalTst = {
    name: 'hp_first_section_vertical_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type HpFirstSectionVerticalTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const HpHideLlmGroupSubheaderTst = {
    name: 'hp_hide_llm_group_subheader_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type HpHideLlmGroupSubheaderTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const HpHvaDashboardTst = {
    name: 'hp_hva_dashboard_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        M1Hva: 1,
        Grp2: 2,
        Grp3: 3,
        Grp4: 4,
    },
} satisfies ProctorSpecification;

export type HpHvaDashboardTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isM1Hva: boolean;
    isGrp2: boolean;
    isGrp3: boolean;
    isGrp4: boolean;
};

export const HpHvaNbaBackendTst = {
    name: 'hp_hva_nba_backend_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type HpHvaNbaBackendTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const HpJobSectionsHeaderV2Tst = {
    name: 'hp_job_sections_header_v2_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type HpJobSectionsHeaderV2TstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const HpJobSectionsTst = {
    name: 'hp_job_sections_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        MobileMvp: 1,
        Desktop: 2,
        Relovertsecond: 3,
        JpAutosourcer: 4,
        Controlrelo: 5,
        Relocarosecond: 6,
        NoGroupedhp: 7,
        Grp8: 8,
        Grp9: 9,
        Grp10: 10,
        Grp11: 11,
        Grp12: 12,
        Grp13: 13,
        JpOnlyJobsforyou: 14,
        Grp15: 15,
        Longcommutethird: 16,
        Control17: 17,
        Test18: 18,
        Control19: 19,
        Test20: 20,
        Test21: 21,
        Test22: 22,
        Test23: 23,
        Control24: 24,
        Test25: 25,
        Test26: 26,
        Test27: 27,
        Test28: 28,
        Test29: 29,
        Test30: 30,
        Test31: 31,
        Test32: 32,
        Test33: 33,
        Test34: 34,
        Test35: 35,
        Control36: 36,
        ControlCopy21: 37,
        Lastapply: 38,
        ControlDesktop: 39,
        DesktopLastapply: 40,
        Mobile41: 41,
        Desktop42: 42,
        ControlCopy41: 43,
        TestCarousel1: 44,
        TestCarousel2: 45,
        TestCarousel3: 46,
        TestCarouselscroll1: 47,
        TestCarouselscroll2: 48,
        Mobile49: 49,
        Desktop50: 50,
        Desktop51: 51,
        MobileCrowtaxoM3Control52: 52,
        MobileCrowtaxoM3Test53: 53,
        DesktopCrowtaxoM3Control54: 54,
        DesktopCrowtaxoM3Test55: 55,
        IosControl56: 56,
        IosCrowtaxoM3Control57: 57,
        IosCrowtaxoM3Test58: 58,
        TestCarouselscroll3: 59,
        MobileCrowtaxoP3Iteration2Ctrl60: 60,
        MobileCrowtaxoP3Iteration2Test61: 61,
        MobileCrowtaxoP3Iteration2Test62: 62,
        DesktopCrowtaxoP3Iteration2Ctrl63: 63,
        DesktopCrowtaxoP3Iteration2Test64: 64,
        DesktopCrowtaxoP3Iteration2Test65: 65,
        ControlMobile: 66,
        TestCarouselV21: 67,
        TestCarouselV22: 68,
        TestCarouselV23: 69,
        UsEmployeroutreach: 70,
        JpMobileJobsforyouAutosourcerblended: 71,
        TestCarouselV24: 72,
        TestCarouselV25: 73,
        TestCarouselV26: 74,
        TestCarouselV27: 75,
        TestCarouselV28: 76,
        TestCarouselV29: 77,
        ExtendedUsHpFifteenAaPlus: 78,
        ExtendedUsHpdFifteenAaPlus: 79,
        CaMobile: 80,
        CaDesktop: 81,
        CaMobileWithAssistedapply: 82,
        MobileRemovePaginationControl: 83,
        MobileRemovePaginationLimit10: 84,
        MobileRemovePaginationLimit100: 85,
        DesktopRemovePaginationControl: 86,
        DesktopRemovePaginationLimit10: 87,
        DesktopRemovePaginationLimit100: 88,
        ControlEmployeroutreach: 89,
        EmployeroutreachAsPmc: 90,
        EmployeroutreachAsPmcSs: 91,
    },
} satisfies ProctorSpecification;

export type HpJobSectionsTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isMobileMvp: boolean;
    isDesktop: boolean;
    isRelovertsecond: boolean;
    isJpAutosourcer: boolean;
    isControlrelo: boolean;
    isRelocarosecond: boolean;
    isNoGroupedhp: boolean;
    isGrp8: boolean;
    isGrp9: boolean;
    isGrp10: boolean;
    isGrp11: boolean;
    isGrp12: boolean;
    isGrp13: boolean;
    isJpOnlyJobsforyou: boolean;
    isGrp15: boolean;
    isLongcommutethird: boolean;
    isControl17: boolean;
    isTest18: boolean;
    isControl19: boolean;
    isTest20: boolean;
    isTest21: boolean;
    isTest22: boolean;
    isTest23: boolean;
    isControl24: boolean;
    isTest25: boolean;
    isTest26: boolean;
    isTest27: boolean;
    isTest28: boolean;
    isTest29: boolean;
    isTest30: boolean;
    isTest31: boolean;
    isTest32: boolean;
    isTest33: boolean;
    isTest34: boolean;
    isTest35: boolean;
    isControl36: boolean;
    isControlCopy21: boolean;
    isLastapply: boolean;
    isControlDesktop: boolean;
    isDesktopLastapply: boolean;
    isMobile41: boolean;
    isDesktop42: boolean;
    isControlCopy41: boolean;
    isTestCarousel1: boolean;
    isTestCarousel2: boolean;
    isTestCarousel3: boolean;
    isTestCarouselscroll1: boolean;
    isTestCarouselscroll2: boolean;
    isMobile49: boolean;
    isDesktop50: boolean;
    isDesktop51: boolean;
    isMobileCrowtaxoM3Control52: boolean;
    isMobileCrowtaxoM3Test53: boolean;
    isDesktopCrowtaxoM3Control54: boolean;
    isDesktopCrowtaxoM3Test55: boolean;
    isIosControl56: boolean;
    isIosCrowtaxoM3Control57: boolean;
    isIosCrowtaxoM3Test58: boolean;
    isTestCarouselscroll3: boolean;
    isMobileCrowtaxoP3Iteration2Ctrl60: boolean;
    isMobileCrowtaxoP3Iteration2Test61: boolean;
    isMobileCrowtaxoP3Iteration2Test62: boolean;
    isDesktopCrowtaxoP3Iteration2Ctrl63: boolean;
    isDesktopCrowtaxoP3Iteration2Test64: boolean;
    isDesktopCrowtaxoP3Iteration2Test65: boolean;
    isControlMobile: boolean;
    isTestCarouselV21: boolean;
    isTestCarouselV22: boolean;
    isTestCarouselV23: boolean;
    isUsEmployeroutreach: boolean;
    isJpMobileJobsforyouAutosourcerblended: boolean;
    isTestCarouselV24: boolean;
    isTestCarouselV25: boolean;
    isTestCarouselV26: boolean;
    isTestCarouselV27: boolean;
    isTestCarouselV28: boolean;
    isTestCarouselV29: boolean;
    isExtendedUsHpFifteenAaPlus: boolean;
    isExtendedUsHpdFifteenAaPlus: boolean;
    isCaMobile: boolean;
    isCaDesktop: boolean;
    isCaMobileWithAssistedapply: boolean;
    isMobileRemovePaginationControl: boolean;
    isMobileRemovePaginationLimit10: boolean;
    isMobileRemovePaginationLimit100: boolean;
    isDesktopRemovePaginationControl: boolean;
    isDesktopRemovePaginationLimit10: boolean;
    isDesktopRemovePaginationLimit100: boolean;
    isControlEmployeroutreach: boolean;
    isEmployeroutreachAsPmc: boolean;
    isEmployeroutreachAsPmcSs: boolean;
};

export const HpRezIncompleteVariantWidgetTst = {
    name: 'hp_rez_incomplete_variant_widget_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
    },
} satisfies ProctorSpecification;

export type HpRezIncompleteVariantWidgetTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
};

export const HpRezWidgetTst = {
    name: 'hp_rez_widget_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Grp1: 1,
        Grp2: 2,
    },
} satisfies ProctorSpecification;

export type HpRezWidgetTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
    isGrp2: boolean;
};

export const IosnativeJsProAutoApplyMyJobsBannerTst = {
    name: 'iosnative_js_pro_auto_apply_my_jobs_banner_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        ControlAa: 1,
        MvpProd: 2,
        MvpQa: 3,
        ReservedA: 4,
        ReservedB: 5,
        ReservedC: 6,
        ReservedD: 7,
        ReservedE: 8,
        ReservedF: 9,
    },
} satisfies ProctorSpecification;

export type IosnativeJsProAutoApplyMyJobsBannerTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isControlAa: boolean;
    isMvpProd: boolean;
    isMvpQa: boolean;
    isReservedA: boolean;
    isReservedB: boolean;
    isReservedC: boolean;
    isReservedD: boolean;
    isReservedE: boolean;
    isReservedF: boolean;
};

export const JcsFjcDisplayTst = {
    name: 'jcs_fjc_display_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Grp1: 1,
        Grp2: 2,
        Grp3: 3,
    },
} satisfies ProctorSpecification;

export type JcsFjcDisplayTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
    isGrp2: boolean;
    isGrp3: boolean;
};

export const JcsHeroJobcardTst = {
    name: 'jcs_hero_jobcard_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Grp1: 1,
        Grp2: 2,
    },
} satisfies ProctorSpecification;

export type JcsHeroJobcardTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
    isGrp2: boolean;
};

export const JcsReportJobTst = {
    name: 'jcs_report_job_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Grp1: 1,
        Grp2: 2,
    },
} satisfies ProctorSpecification;

export type JcsReportJobTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
    isGrp2: boolean;
};

export const JsProAutoApplyBrandTst = {
    name: 'js_pro_auto_apply_brand_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        NoBrand: 1,
    },
} satisfies ProctorSpecification;

export type JsProAutoApplyBrandTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isNoBrand: boolean;
};

export const JsProAutoApplySqPrefillTst = {
    name: 'js_pro_auto_apply_sq_prefill_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
        ReservedA: 2,
        ReservedB: 3,
        ReservedC: 4,
        ReservedD: 5,
    },
} satisfies ProctorSpecification;

export type JsProAutoApplySqPrefillTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
    isReservedA: boolean;
    isReservedB: boolean;
    isReservedC: boolean;
    isReservedD: boolean;
};

export const JsjJobseekerRelevanceSurveyPilotAccountTst = {
    name: 'jsj_jobseeker_relevance_survey_pilot_account_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
    },
} satisfies ProctorSpecification;

export type JsjJobseekerRelevanceSurveyPilotAccountTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
};

export const JsjJobseekerRelevanceSurveyPilotTst = {
    name: 'jsj_jobseeker_relevance_survey_pilot_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
    },
} satisfies ProctorSpecification;

export type JsjJobseekerRelevanceSurveyPilotTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
};

export const JsjNpsAfterJobSaveTst = {
    name: 'jsj_nps_after_job_save_tst',
    buckets: {
        Rotate: -2,
        Inactive: -1,
        Control: 0,
        Grp1: 1,
    },
} satisfies ProctorSpecification;

export type JsjNpsAfterJobSaveTstAllocation = {
    value: number;
    payloadJson: string | null;
    isRotate: boolean;
    isInactive: boolean;
    isControl: boolean;
    isGrp1: boolean;
};

export const JsjRemoveNewTextFromRecentSearchesTst = {
    name: 'jsj_remove_new_text_from_recent_searches_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type JsjRemoveNewTextFromRecentSearchesTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const JsjUpdateRecentSearchesWordingTst = {
    name: 'jsj_update_recent_searches_wording_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type JsjUpdateRecentSearchesWordingTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const JsmaEvergreenNativeEvent = {
    name: 'jsma_evergreen_native_event',
    buckets: {
        Inactive: -1,
        Control: 0,
        Evergreen: 1,
    },
} satisfies ProctorSpecification;

export type JsmaEvergreenNativeEventAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isEvergreen: boolean;
};

export const JsmaTempLocaleLogHp = {
    name: 'jsma_temp_locale_log_hp',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type JsmaTempLocaleLogHpAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const JsoStructuredLocationValidationTst = {
    name: 'jso_structured_location_validation_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        StructuredValidation: 1,
    },
} satisfies ProctorSpecification;

export type JsoStructuredLocationValidationTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isStructuredValidation: boolean;
};

export const ProfHpResumeAiColdstartTst = {
    name: 'prof_hp_resume_ai_coldstart_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        ActiveA: 1,
        ActiveB: 2,
        ActiveC: 3,
    },
} satisfies ProctorSpecification;

export type ProfHpResumeAiColdstartTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActiveA: boolean;
    isActiveB: boolean;
    isActiveC: boolean;
};

export const RnMarketTrends = {
    name: 'rn_market_trends',
    buckets: {
        Inactive: -1,
        Control: 0,
        ControlAa: 1,
        Active: 2,
        ActiveA: 3,
        ActiveB: 4,
        ReserveA: 5,
        ReserveB: 6,
    },
} satisfies ProctorSpecification;

export type RnMarketTrendsAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isControlAa: boolean;
    isActive: boolean;
    isActiveA: boolean;
    isActiveB: boolean;
    isReserveA: boolean;
    isReserveB: boolean;
};

export const RnMarketTrendsVideoShorts = {
    name: 'rn_market_trends_video_shorts',
    buckets: {
        Inactive: -1,
        Control: 0,
        ControlAa: 1,
        Active: 2,
        ReserveA: 3,
        ReserveB: 4,
    },
} satisfies ProctorSpecification;

export type RnMarketTrendsVideoShortsAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isControlAa: boolean;
    isActive: boolean;
    isReserveA: boolean;
    isReserveB: boolean;
};

export const RnNpsParentTst = {
    name: 'rn_nps_parent_tst',
    buckets: {
        Rotate: -2,
        Inactive: -1,
        Control: 0,
        Shownps: 1,
    },
} satisfies ProctorSpecification;

export type RnNpsParentTstAllocation = {
    value: number;
    payloadJson: string | null;
    isRotate: boolean;
    isInactive: boolean;
    isControl: boolean;
    isShownps: boolean;
};

export const RnhpAutoApplyBannerTst = {
    name: 'rnhp_auto_apply_banner_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
        ProgressiveAutomation: 2,
        LegacyBannerTestA: 3,
        LegacyBannerTestB: 4,
        ControlA: 5,
        ControlB: 6,
        ReservedA: 7,
        ReservedB: 8,
        ReservedC: 9,
    },
} satisfies ProctorSpecification;

export type RnhpAutoApplyBannerTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
    isProgressiveAutomation: boolean;
    isLegacyBannerTestA: boolean;
    isLegacyBannerTestB: boolean;
    isControlA: boolean;
    isControlB: boolean;
    isReservedA: boolean;
    isReservedB: boolean;
    isReservedC: boolean;
};

export const RnhpAutoApplyDislikeFormTst = {
    name: 'rnhp_auto_apply_dislike_form_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type RnhpAutoApplyDislikeFormTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const RnhpAutoApplyFeedbackModalTog = {
    name: 'rnhp_auto_apply_feedback_modal_tog',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type RnhpAutoApplyFeedbackModalTogAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const RnhpAutoApplyRbsJobCarouselTst = {
    name: 'rnhp_auto_apply_rbs_job_carousel_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type RnhpAutoApplyRbsJobCarouselTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const RnhpContentCollectionTst = {
    name: 'rnhp_content_collection_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type RnhpContentCollectionTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const RnhpExpandedLocationModalTst = {
    name: 'rnhp_expanded_location_modal_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Test: 1,
    },
} satisfies ProctorSpecification;

export type RnhpExpandedLocationModalTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isTest: boolean;
};

export const RnhpJobsApiMigration = {
    name: 'rnhp_jobs_api_migration',
    buckets: {
        Inactive: -1,
        Control: 0,
        Active: 1,
    },
} satisfies ProctorSpecification;

export type RnhpJobsApiMigrationAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isActive: boolean;
};

export const RnhpNavRefreshTst = {
    name: 'rnhp_nav_refresh_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        ControlAa: 1,
        Active: 2,
    },
} satisfies ProctorSpecification;

export type RnhpNavRefreshTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isControlAa: boolean;
    isActive: boolean;
};

export const RnhpNpsTst = {
    name: 'rnhp_nps_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        Shownps: 1,
    },
} satisfies ProctorSpecification;

export type RnhpNpsTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isShownps: boolean;
};

export const RnhpPreferenceChipsJobTitleTst = {
    name: 'rnhp_preference_chips_job_title_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        ControlAa: 1,
        ActiveA: 2,
        ActiveB: 3,
    },
} satisfies ProctorSpecification;

export type RnhpPreferenceChipsJobTitleTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isControlAa: boolean;
    isActiveA: boolean;
    isActiveB: boolean;
};

export const RnhpPreferenceChipsLocationTst = {
    name: 'rnhp_preference_chips_location_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        ControlAa: 1,
        Active: 2,
    },
} satisfies ProctorSpecification;

export type RnhpPreferenceChipsLocationTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isControlAa: boolean;
    isActive: boolean;
};

export const RnhpPreferenceChipsPayTst = {
    name: 'rnhp_preference_chips_pay_tst',
    buckets: {
        Inactive: -1,
        Control: 0,
        ControlAa: 1,
        Active: 2,
    },
} satisfies ProctorSpecification;

export type RnhpPreferenceChipsPayTstAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isControlAa: boolean;
    isActive: boolean;
};

export const RnhpVj = {
    name: 'rnhp_vj',
    buckets: {
        Inactive: -1,
        Control: 0,
        ControlAa: 1,
        Grp2: 2,
        Grp3: 3,
        Grp4: 4,
        Grp5: 5,
    },
} satisfies ProctorSpecification;

export type RnhpVjAllocation = {
    value: number;
    payloadJson: string | null;
    isInactive: boolean;
    isControl: boolean;
    isControlAa: boolean;
    isGrp2: boolean;
    isGrp3: boolean;
    isGrp4: boolean;
    isGrp5: boolean;
};

export type HomepageProctorSpecification =
    | typeof AutoApplyRebrandingTst
    | typeof BrandedjobMigrationRnhpTst
    | typeof DiscoLimitedUiTst
    | typeof HpCarouselV4Tst
    | typeof HpFirstSectionVerticalTst
    | typeof HpHideLlmGroupSubheaderTst
    | typeof HpHvaDashboardTst
    | typeof HpHvaNbaBackendTst
    | typeof HpJobSectionsHeaderV2Tst
    | typeof HpJobSectionsTst
    | typeof HpRezIncompleteVariantWidgetTst
    | typeof HpRezWidgetTst
    | typeof IosnativeJsProAutoApplyMyJobsBannerTst
    | typeof JcsFjcDisplayTst
    | typeof JcsHeroJobcardTst
    | typeof JcsReportJobTst
    | typeof JsProAutoApplyBrandTst
    | typeof JsProAutoApplySqPrefillTst
    | typeof JsjJobseekerRelevanceSurveyPilotAccountTst
    | typeof JsjJobseekerRelevanceSurveyPilotTst
    | typeof JsjNpsAfterJobSaveTst
    | typeof JsjRemoveNewTextFromRecentSearchesTst
    | typeof JsjUpdateRecentSearchesWordingTst
    | typeof JsmaEvergreenNativeEvent
    | typeof JsmaTempLocaleLogHp
    | typeof JsoStructuredLocationValidationTst
    | typeof ProfHpResumeAiColdstartTst
    | typeof RnMarketTrends
    | typeof RnMarketTrendsVideoShorts
    | typeof RnNpsParentTst
    | typeof RnhpAutoApplyBannerTst
    | typeof RnhpAutoApplyDislikeFormTst
    | typeof RnhpAutoApplyFeedbackModalTog
    | typeof RnhpAutoApplyRbsJobCarouselTst
    | typeof RnhpContentCollectionTst
    | typeof RnhpExpandedLocationModalTst
    | typeof RnhpJobsApiMigration
    | typeof RnhpNavRefreshTst
    | typeof RnhpNpsTst
    | typeof RnhpPreferenceChipsJobTitleTst
    | typeof RnhpPreferenceChipsLocationTst
    | typeof RnhpPreferenceChipsPayTst
    | typeof RnhpVj;

export type HomepageProctorAllocation =
    | AutoApplyRebrandingTstAllocation
    | BrandedjobMigrationRnhpTstAllocation
    | DiscoLimitedUiTstAllocation
    | HpCarouselV4TstAllocation
    | HpFirstSectionVerticalTstAllocation
    | HpHideLlmGroupSubheaderTstAllocation
    | HpHvaDashboardTstAllocation
    | HpHvaNbaBackendTstAllocation
    | HpJobSectionsHeaderV2TstAllocation
    | HpJobSectionsTstAllocation
    | HpRezIncompleteVariantWidgetTstAllocation
    | HpRezWidgetTstAllocation
    | IosnativeJsProAutoApplyMyJobsBannerTstAllocation
    | JcsFjcDisplayTstAllocation
    | JcsHeroJobcardTstAllocation
    | JcsReportJobTstAllocation
    | JsProAutoApplyBrandTstAllocation
    | JsProAutoApplySqPrefillTstAllocation
    | JsjJobseekerRelevanceSurveyPilotAccountTstAllocation
    | JsjJobseekerRelevanceSurveyPilotTstAllocation
    | JsjNpsAfterJobSaveTstAllocation
    | JsjRemoveNewTextFromRecentSearchesTstAllocation
    | JsjUpdateRecentSearchesWordingTstAllocation
    | JsmaEvergreenNativeEventAllocation
    | JsmaTempLocaleLogHpAllocation
    | JsoStructuredLocationValidationTstAllocation
    | ProfHpResumeAiColdstartTstAllocation
    | RnMarketTrendsAllocation
    | RnMarketTrendsVideoShortsAllocation
    | RnNpsParentTstAllocation
    | RnhpAutoApplyBannerTstAllocation
    | RnhpAutoApplyDislikeFormTstAllocation
    | RnhpAutoApplyFeedbackModalTogAllocation
    | RnhpAutoApplyRbsJobCarouselTstAllocation
    | RnhpContentCollectionTstAllocation
    | RnhpExpandedLocationModalTstAllocation
    | RnhpJobsApiMigrationAllocation
    | RnhpNavRefreshTstAllocation
    | RnhpNpsTstAllocation
    | RnhpPreferenceChipsJobTitleTstAllocation
    | RnhpPreferenceChipsLocationTstAllocation
    | RnhpPreferenceChipsPayTstAllocation
    | RnhpVjAllocation;

export const HomepageProctorSpecifications = [
    AutoApplyRebrandingTst,
    BrandedjobMigrationRnhpTst,
    DiscoLimitedUiTst,
    HpCarouselV4Tst,
    HpFirstSectionVerticalTst,
    HpHideLlmGroupSubheaderTst,
    HpHvaDashboardTst,
    HpHvaNbaBackendTst,
    HpJobSectionsHeaderV2Tst,
    HpJobSectionsTst,
    HpRezIncompleteVariantWidgetTst,
    HpRezWidgetTst,
    IosnativeJsProAutoApplyMyJobsBannerTst,
    JcsFjcDisplayTst,
    JcsHeroJobcardTst,
    JcsReportJobTst,
    JsProAutoApplyBrandTst,
    JsProAutoApplySqPrefillTst,
    JsjJobseekerRelevanceSurveyPilotAccountTst,
    JsjJobseekerRelevanceSurveyPilotTst,
    JsjNpsAfterJobSaveTst,
    JsjRemoveNewTextFromRecentSearchesTst,
    JsjUpdateRecentSearchesWordingTst,
    JsmaEvergreenNativeEvent,
    JsmaTempLocaleLogHp,
    JsoStructuredLocationValidationTst,
    ProfHpResumeAiColdstartTst,
    RnMarketTrends,
    RnMarketTrendsVideoShorts,
    RnNpsParentTst,
    RnhpAutoApplyBannerTst,
    RnhpAutoApplyDislikeFormTst,
    RnhpAutoApplyFeedbackModalTog,
    RnhpAutoApplyRbsJobCarouselTst,
    RnhpContentCollectionTst,
    RnhpExpandedLocationModalTst,
    RnhpJobsApiMigration,
    RnhpNavRefreshTst,
    RnhpNpsTst,
    RnhpPreferenceChipsJobTitleTst,
    RnhpPreferenceChipsLocationTst,
    RnhpPreferenceChipsPayTst,
    RnhpVj,
];